module.exports = __webpack_public_path__ + "img/a043fadc7ac2003262a620b43e6ef035.png";